/**
 * Created by Nisarg on 7/19/2017.
 */
import React, {Component} from 'react';

export default class LoginSection extends Component {
    render() {
        return (
            <div className="login-sec">
                <div className="login-page">
                    <span className="sign-up">Sign up with <span className="color-text">Facebook</span> or <span
                        className="color-text">Google</span></span>
                    <span className="optional">or</span>
                    <form className="login-form">
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder="Email"/>
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Name"/>
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder="Phone"/>
                        </div>
                        <div className="form-group">
                            <input type="text" className="form-control" placeholder=""/>
                        </div>
                        <div className="form-group birth-wrap">
                            <label className="label">Birthday</label>
                            <select className="month-sec form-control">
                                <option>Month</option>
                                <option>Jan</option>
                                <option>Feb</option>
                            </select>
                            <select className="date-sec form-control">
                                <option>Day</option>
                                <option>1</option>
                                <option>2</option>
                            </select>
                            <select className="year-sec form-control">
                                <option>Year</option>
                                <option>2017</option>
                                <option>2016</option>
                            </select>
                        </div>
                        <div className="form-group textarea-wrap">
                            <textarea className="textarea-control form-control" placeholder="Enquiry"></textarea>
                        </div>
                        <button className="sign-btn button">Sign up</button>
                    </form>
                    <a href="#0" className="close-btn"><img src="../../assets/images/cross.png"
                                                            alt=""/></a>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/LoginSection.js